import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoWand = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Wand</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m9.119 9.073-4.04-1.088 4.04-1.087 1.087-4.04 1.087 4.04 4.041 1.087-4.04 1.088-1.088 4.04-1.087-4.04ZM17.356 5.965l-2.02-.544 2.02-.543.544-2.02.544 2.02 2.02.543-2.02.544-.544 2.02-.544-2.02ZM26.759 19.359l-2.526-.68L26.76 18l.68-2.525.679 2.526 2.526.68-2.526.679-.68 2.525-.68-2.525Z"
      fill="currentColor"
    />
    <path
      d="m21.127 15.678-2.563-2.564"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x={24.377}
      y={6.408}
      width={5.219}
      height={29.489}
      rx={1.714}
      transform="rotate(45 24.377 6.408)"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoWand;
